import React, { useMemo } from "react";
import { useParams } from "react-router";
import EventsView from "screens/events/component/event/view";
import { useSelector } from "react-redux";
import { getEventData } from "features/shared-event/redux/selectors";

const Events = () => {
  const { hash } = useParams();
  const eventData = useSelector(getEventData);

  const eventProps = useMemo(() => {
    if (eventData) {
      return {
        hash,
        isNominated: eventData.is_nominated,
        isLiveEvent: Boolean(eventData?.location?.is_online),
        guestName: eventData.guest_first_name,
        invitedBy: eventData.invited_by,
        eventName: eventData.activation_name,
        locationName: eventData.location.name,
        eventDate: eventData.activation_starts_at,
        eventEnd: eventData.activation_ends_at,
        eventDescription: eventData.activation_description,
        eventTicketPrice: eventData.ticket_price,
        eventTicketCurrency:
          eventData.ticket_price_currency &&
          eventData.ticket_price_currency.symbol,
        guests: eventData.guests,
        eventLocation: eventData.location,
        eventImages: eventData.image_urls,
        showLiveEventTime: eventData.show_live_button_before_start_minutes,
      };
    } else {
      location.href = `/share/${hash}`;
    }
  }, [eventData]);

  const addEvent = (event) => {
    const ics = require("ics");

    ics.createEvent(event, (error, value) => {
      if (error) {
        console.log(error);
      }

      const url = window.URL.createObjectURL(
        new Blob([value], { type: "text/calendar" })
      );
      const a = document.createElement("a");
      document.body.appendChild(a);
      a.style.display = "none";
      a.href = url;
      a.download = event.title;
      a.target = "_self";
      a.click();

      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      }, 0);
    });
  };

  return <EventsView {...eventProps} addEvent={addEvent} />;
};

export default Events;
